module.exports = __webpack_public_path__ + "img/linkedln.8d61574c.svg";